import Center from "../../assets/images/product/insideEco/center.webp";
import Left from "../../assets/images/product/insideEco/left.webp";
import InsideEco from "../../assets/images/products/insideEco.webp";
import { categoriesOfPaints } from "../categoryOfPaints";

export const insideEco = {
  category: [categoriesOfPaints.interior],
  path: "festek_inside_eco",
  name: "FESTEK-INSIDE ECO",
  header: "Краска интерьерная акриловая\n«FESTEK-INSIDE ECO»",
  link: "https://drive.google.com/file/d/1sp5lSEsvce0S5-VL-xQ7IXCuSIRAko9T/view?usp=sharing",
  purchase: [
    {
      price: "65,00",
      amount: "15 кг",
    },
  ],
  productsPage: {
    title: "Интерьерная «FESTEK-INSIDE ECO»",
    text: "Матовая краска для окраски стен и потолков с умеренной эксплуатационной нагрузкой",
  },
  images: {
    products: InsideEco,
    product: [Center, Left],
  },
  documentation: {
    description: {
      concept: {
        value:
          "это интерьерная краска, которая предназначена для окраски стен и потолков в жилых и административных помещениях с умеренной влажностью и стандартной эксплуатационной нагрузкой (спальни, гостиные, коридоры, холлы, офисные помещения). Допускается нанесение по обоям, предназначенным под покраску.",
        label: "FESTEK «INSIDE ECO»",
      },

      properties: {
        value: [
          "Образует матовое «дышащее» покрытие.",
          "Обладающее высокой укрывистостью.",
          "Не разбрызгивается, легко наносится.",
          "Устойчива к легкой влажной уборке.",
          "Имеет насыщенный белый оттенок.",
        ],
        label: "Преимущество",
      },

      consumption: {
        value:
          "На двухслойное покрытие – 350 - 400 г/м2. Зависит от пористости поверхности, применяемого оборудования, квалификации персонала, погодных условий. При окрашивании фактурных поверхностей (типа: шуба, барашек, короед и т.п.) расход краски увеличивается в 1,5 раза.",
        label: "Расход",
      },

      package: {
        value: "11 литров – 15 килограмм; 20 литров – 25 килограмм.",
        label: "Упаковка",
      },

      suitableSubstrates: {
        value:
          "Бетонные, кирпичные, оштукатуренные, гипсокартонные и другие минеральные поверхности; допускается нанесение по обоям, предназначенным под покраску.",
        label: "Пригодные подложки",
      },

      coatingSystem: {
        value:
          "Для получения качественного покрытия и снижения расхода краски поверхность обработать грунтовкой «Festek-Grunt» для глубокого проникновения или «Festek-MaxiGrunt», исходя из рекомендаций по применению. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %",
        label: "Система покрытия",
      },

      colorSolutions: {
        value:
          "Белый + цвета по большинству колеровочных системы. Возможен подбор цвета по вашему образцу. Богатую палитру цветов можете выбрать у нас сайте",
        label: "Цветовые решения",
      },
    },

    applicationTechnology: {
      composition: {
        value:
          "Водная дисперсия акриловых сополимеров, пигменты, наполнители, функциональные добавки, вода.",
        label: "Состав",
      },

      preparationSurfaces: {
        value:
          "Поверхность очистить от пыли, грязи, разделительных жидкостей, меловых, известковых, непрочно держащихся и несовместимых покрытий (силикатные, масляные и т.п.), должен отсутствовать эффект меления. Биопоражения и высолы удалить механически, при необходимости обработать специальными составами. Глянцевые основания зашлифовать и обеспылить. Новые бетонные поверхности окрашивать не ранее, чем через 28 дней, оштукатуренные полимерминеральными составами – не ранее, чем через 7 дней после их естественного высыхания (или согласно рекомендациям производителя).",
        label: "Подготовка поверхности",
      },

      methodAndConditionsDrawing: {
        value:
          "Работы проводить при температуре окружающего воздуха, краски и окрашиваемой поверхности не ниже 10 °С и не выше 25 °С. Не допускается нанесение при неблагоприятных погодных условиях (дождь, туман, выпадение росы, сильный ветер более 10 м/с). Не наносить краску на сильно нагретую поверхность, находящуюся под прямыми солнечными лучами. При проведении окрасочных работ влажность основания должна быть не более 8 %, влажность воздуха – не более 80 %. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %. Перед применением краску тщательно перемешать и наносить на поверхность: •\u00A0Кистью; •\u00A0Валиком; •\u00A0Пневматическим или безвоздушным методом распыления; Упаковку с частично использованным материалом тщательно закрыть, а ее содержимое использовать в наиболее короткий срок. Краска одного цвета, но различных партий может незначительно отличаться по тону. Для исключения разнооттеночности получаемого покрытия следует выбирать краску одной партии или смешивать необходимое количество материала различных партий в отдельной емкости. После работы инструмент, пятна отмыть теплой водой с мылом до высыхания краски.",
        label: "Способ и условия нанесения",
      },

      temperature: {
        value:
          "Промежуточная сушка каждого слоя в течение 4 ч при температуре (20±2) °С. При более низкой температуре и/или повышенной влажности время высыхания может увеличиваться до 24 ч. Время выдержки покрытия до первой влажной уборки – не менее 21 суток.",
        label: "Температурный режим, время высыхания",
      },

      endlessApplication: {
        value:
          'При нанесении краскопультом (безвоздушное) рекомендуются след. параметры: угол распыления 60°, диаметр сопла 0,53-0,58 мм (0,021"-0,023" дюйма), Давление 175-180 bar.',
        label: "Безвоздушное нанесение",
      },
    },

    technicalData: [
      {
        qualityIndicators: "Массовая доля нелетучих веществ, %",
        value: "56 - 68",
      },
      {
        qualityIndicators: "Показатель концентрации ионов водорода, pH",
        value: "7,0 - 9,5",
      },
      {
        qualityIndicators: "Степень перетира, мкм, не более",
        value: "70",
      },
      {
        qualityIndicators:
          "Время высыхания до степени 3 при температуре (20±2) °С, ч, не более",
        value: "1",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к статическому воздействию воды при температуре (20±2) °С, ч, не менее",
        value: "24",
      },
    ],
  },
};
